import { render, staticRenderFns } from "./HomeInsurance.vue?vue&type=template&id=dd328990&scoped=true"
import script from "./HomeInsurance.vue?vue&type=script&lang=js"
export * from "./HomeInsurance.vue?vue&type=script&lang=js"
import style0 from "./HomeInsurance.vue?vue&type=style&index=0&id=dd328990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd328990",
  null
  
)

export default component.exports